import { ProjectPhase } from "./enum/project-phase.mjs"

export function setPhaseBadgeColor(phase) {
    switch (phase) {
        case ProjectPhase.IN_PROGRESS:
            return "authoringInProgress"
        case ProjectPhase.PUSHED_TO_LEGACY:
            return "authoringProjectSentToLegacy"
        case ProjectPhase.PUBLISHED_TO_LEGACY:
            return "authoringProjectPublishedToLegacy"
        default:
            return ""
    }
}
